export default class AttributeSelector {

    constructor($view) {
        this.$view = $view;
        let vars = this.$view.data("variants") + "";
        this.$selects = this.$view.find("select");
        this.variants = vars.split(',');
        this.refreshing = false;
        window.$("select").selectpicker();
        this.bind();
    }

    bind() {
        var self = this;
        this.hasFirstChange = [];
        this.$selects.each(function (i, select) {
            $(select).on("change", function (e) {
                if (self.timeout) {
                    window.clearTimeout(self.timeout);
                }
                let ddl = $(this);
                self.timeout = setTimeout(function() { self.filter(ddl); }, 300);
                //self.filter($(this));
            });
        });

        // Pour sélectionner la seule option éventuelle au chargment de la page :

        // let toRefresh = false;
        // this.$selects.each(function (i, select) {
        //    let options = $(select).find("option");
        //    // si 2 : default + seule valeur. on sélectionne la valeur
        //     if (options.length == 2) {
        //         $(select).val($(options[1]).val());
        //         $(options[1]).prop("selected",true);
        //         toRefresh = true;
        //     }
        // });
        // if (toRefresh) {
        //     window.$("select").selectpicker("refresh");
        //     //this.filter();
        // }

    }

    intersect(a, b) {
        return a.filter(Set.prototype.has, new Set(b));
    }

    filter(modifiedSelect) {
        let self = this;
        let variants = self.variants;
        // on prend toutes les options selectionnées
        let selected = this.$view.find("option:selected");
        selected.each(function (i, o) {
            let v = $(o).data("variants") + '';
            let selectedVars = v.split(",");
            variants = self.intersect(variants, selectedVars);
        });

        // il n'en reste aucune : on reset les autres options
        if (variants.length == 0) {
            this.$selects.each(function (i, select) {
                if ($(select).prop("id") != modifiedSelect.prop("id")) {
                    $(select).val(-1);
                }
            });
            this.filter(modifiedSelect);
            return;
        }

        // on masque toutes les options qui n'ont pas une variante encore dispo
        this.$selects.each(function (i, select) {
            let nb = 0;
            let currentVal = "";
            $(select).find("option").each(function (i, o) {
                let index = $(o).index();
                let v = $(o).data("variants") + '';
                let optionsV = v.split(",");
                let commonV = self.intersect(variants, optionsV);
                if (commonV.length > 0) {
                    $(o).removeClass("unavailable");
                    currentVal = $(o).val();
                    nb++;
                } else {
                    $(o).addClass("unavailable");
                    if ($(select).val() == $(o).val()) {
                        $(select).val("-1");
                    }
                }
            });
        });


        // pour chaque select, s'il ne contient qu'une valeur on la selectionne
        this.$selects.each(function (i, select) {
            // une seule option sans classe "unavailable" (la dernière puisque la premiere est le placeholder)
            let still = $(select).find("option").not('.unavailable');
            if (still.length==2) {
                $(select).val(still.last().val());
            }
        });

        // s'il ne reste qu'une variante, on la sélectionne dans la liste cachée pour mettre à jour la fiche produit (stock, c&c, ...)
        if (variants.length == 1) {
            this.selectVariant(variants[0]);
        //    window.$("select").prop('disabled', true);

        } else {
            this.selectVariant(0);
        }
        this.refreshing = true;
        window.$("select").selectpicker("refresh");
        this.refreshing = false;

    }
    selectVariant(id) {
        $("#variant_id").find('option').prop("selected",false);
        $("#variant_id").find("option[value='" + id + "']").prop("selected",true);
        updateVariant($("#variant_id"));
    }
}


// WEBPACK FOOTER //
// ./public/frontend/js/components/AttributeSelector.js